import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';
import transferencia from './transferencia';

const state = {
    viaticoId: 0,
    devolucion: false,

    cajaRegistroId: 0,
    cajaRegistro: null,
    cajaRegistroNombre: null,

    pesos: 0,
    importeTransferencias: 0,
    transferencias: [],


};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.viaticoId = params.viaticoId;
        state.devolucion = (/true/i).test(params.devolucion);
        
        state.cajaRegistroId = 0;
        state.cajaRegistro = null;
        state.cajaRegistroNombre = null;

        inicializarDocumentos (state);
    },
    'INICIALIZAR_DOCUMENTOS'(state) {
        inicializarDocumentos (state);
    },
    'SET_CAJA_REGISTRO' (state, cajaRegistro) {
        state.cajaRegistro = cajaRegistro;
        if (cajaRegistro) {
            state.cajaRegistroId = cajaRegistro.id? cajaRegistro.id : 0;
            state.cajaRegistroNombre = cajaRegistro.nombre? cajaRegistro.nombre.toUpperCase().trim() : null;
        } else {
            state.cajaRegistroId = 0;
            state.cajaRegistroNombre = null;
        }
    },
    'SET_TRANSFERENCIA' (state, transferencia) {
        state.transferencias.push(transferencia);

        if (state.transferencias.lenght != 0) {
            state.importeTransferencias = state.transferencias
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTransferencias = 0;
        }
    },
    'DELETE_TRANSFERENCIA' (state, transferencia) {
        let itemKey = state.transferencias
            .findIndex(t => t == transferencia);

        if (itemKey != -1) {
            state.transferencias.splice(itemKey, 1);
        }

        if (state.transferencias.lenght != 0) {
            state.importeTransferencias = state.transferencias
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTransferencias = 0;
        }
    },
};

function inicializarDocumentos (state) {
    state.pesos = 0;
    state.importeTransferencias = 0;
    
    state.transferencias = [];
}

function getTotalDocumentos (state) {
    return parseFloat(state.pesos) 
        + parseFloat(state.importeTransferencias);
}

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            /* Recuperamos la caja central */
            apiAxios.get('cajas/central')
                .then((res) => {
                    commit("SET_CAJA_REGISTRO", res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            let totalDocumentos = getTotalDocumentos(state);

            if (totalDocumentos == 0) {
                save = false;
                errorMessage = "El total de documentos incluidos en el pago no puede ser igual a cero."
            }

            if (save) {
                /* Si es una devolución, doy vuelta el signo */
                let pesos = parseFloat(state.pesos);
                let transferencias = state.transferencias;

                if ((/true/i).test(state.devolucion)) {
                    pesos = -1 * pesos;

                    transferencias.forEach(transferencia => {
                        transferencia.importe = -1 * transferencia.importe;
                    });
                }

                let viaticoPago = {
                    cajaRegistroId: state.cajaRegistroId,
                    pesos,
                    transferencias
                }

                apiAxios.post('viaticos/' + state.viaticoId + '/pago', viaticoPago)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setCajaRegistro ( { commit }, cajaRegistro ) {
        commit('SET_CAJA_REGISTRO', cajaRegistro);
    },
    setTransferencia ( { commit }, transferencia ) {
        commit('SET_TRANSFERENCIA', transferencia);
    },
    deleteTransferencia ( { commit }, transferencia ) {
        commit('DELETE_TRANSFERENCIA', transferencia);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}